import { el } from '../../utils/dom';

export function createLockedPanel(title: string, lines: string[]): HTMLElement {
  const box = el('div', { className: 'ev123-locked__overlay' });
  box.append(el('h2', { className: 'ev123-locked__title', text: title }));
  for (const line of lines) {
    const p = el('p', { className: 'ev123-card__desc', text: line });
    p.style.margin = '0 0 8px';
    box.append(p);
  }
  return box;
}
